import { Component, computed, input, output, signal } from '@angular/core';
import { CategoryField, CategoryFields } from '../../../services/metadata';
import { CheckboxComponent } from '@cumlaude/shared-components-inputs';
import { DataExportRowComponent } from '../data-export-row/data-export-row.component';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-data-export-categorie',
	templateUrl: './data-export-categorie.component.html',
	styleUrls: ['./data-export-categorie.component.scss'],
	imports: [CheckboxComponent, DataExportRowComponent, IconComponent],
})
export class DataExportCategorieComponent {
	readonly categorie = input.required<CategoryFields>();

	readonly selection = input.required<CategoryField[]>();

	readonly first = input.required<boolean>();

	categorieSelected = output<CategoryFields>();

	columnSelected = output<CategoryField>();

	readonly expanded = signal(true);

	readonly checkState = computed(() => {
		const categorie = this.categorie();

		const selected = this.selection().filter((field) => categorie.atts.some((att) => att.att === field.att)).length;

		if (selected === categorie.atts.length) return true;
		else if (selected > 0) return 'indeterminate';
		else return false;
	});

	isColumnSelected(column: CategoryField) {
		return this.selection().some((field) => field.att === column.att);
	}
}
